var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var DEFAULT_BATCH_SIZE = 10;
export var batchEvents = function (events, maxBatchSize) {
    if (events === void 0) { events = []; }
    if (maxBatchSize === void 0) { maxBatchSize = DEFAULT_BATCH_SIZE; }
    var doNotBatch = events.length < maxBatchSize || maxBatchSize === 0;
    if (doNotBatch)
        return [__spreadArray([], events, true)];
    return events.reduce(function (batches, event, i) {
        var chunkIndex = Math.floor(i / maxBatchSize);
        batches[chunkIndex] = __spreadArray(__spreadArray([], (batches[chunkIndex] || []), true), [event], false);
        return batches;
    }, []);
};
